<template>
  <!-- 欢乐豆面值管理 -->
  <div class="container">
    <div class="clearfix">
      <!-- <Form @submit.native.prevent :model="formData" label-position="left">
       <FormItem label="日期范围:" class="fl mytable-title " :label-width="72">
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"8
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
        </Form> -->
      <Button type="primary" @click="addEdit(0)" class="fr">添加消息</Button>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <!--滚动消息-->
    <Modal
      v-model="modalVisibile"
      width="724"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel" 
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        label-position="top"
      >
        <div class="clearfix mb32">         
          <FormItem label="时间范围">
              <Date-picker :options="options" v-model.trim="date" type="datetimerange" placeholder="选择日期和时间" style="width: 400px" @on-change="handleDateChange1"></Date-picker>   
          </FormItem>
          <FormItem label="消息内容" class="mt20">
            <Input
              v-model="modalForm.document"
              style="width: 650px;height:123px;"
              type="textarea"
              placeholder="请输入消息内容"
            ></Input>
        </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getCookie } from "../../libs/util";
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";
export default {
  mixins: [mixins],
  name: "authorManage",
  components: {
  },
  data() {
    return {
       options: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      cashBox: [],
      cashList: [],
      date: [],
      activity_start_time: "",
      activity_end_time: "",
      modalVisibileTime: false,
      day: "0",
      hour: "00",
      min: "00",
      second: "00",
      modalFormTime: {
        title: ""
      },
      imgSrc: "",
      authorId: "",
      formData: {},
      formData1: {},
      cashNum: [],
      modalForm: {},
      modalForm1: {},
      tableLoading: false,
      modalTitle: "添加作者",
      modalVisibile: false,
      tableData: [],
      modalLoading: false,
      modalRule: {
        cash_name: [
          { required: true, message: "请输入代金券名称", trigger: "blur" }
        ],
        cash_money: [
          { required: true, message: "请输入代金券金额", trigger: "blur" }
        ],
        convert_integral: [
          { required: true, message: "兑换所需积分", trigger: "blur" }
        ]
      },
      columns: [
        {
          title: "内容",
          key: "document",
          minWidth: 80
        },
        {
          title: "时间范围",
          key: "bean_number",
          minWidth: 120,
          render:(h,params)=>{
            return h('div',params.row.start_time+' ~ '+params.row.end_time)
          }
        },
        {
          title: "操作",
          key: "caozuo",
          width: 170,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true
                  },
                  on: {
                    click: () => this.addEdit(params)
                  }
                },
                "编辑"
              ),
              h("i", {
                class: {
                  sline: true
                }
              }),
              h(
                "span",
                {
                  class: {
                    btn_del: true
                  },
                  on: {
                    click: () => this.handleDel(params)
                  }
                },
                "删除"
              )

            ]);
          }
        }
        
      ]
    };
  }, 
 
  mounted() {
    this.handleQuery();
  },
  methods: {  
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.modalFormTime.start_time = val[0];
        this.modalFormTime.end_time = val[1];
      } else {
        this.modalFormTime.start_time = "";
        this.modalFormTime.end_time = "";
      }
    },
    //新增消息的时间
    handleDateChange1(val) {
      if (val[0]) {
        this.modalForm.startTime = val[0];
        this.modalForm.endTime = val[1];
      } else {
        this.modalForm.startTime = "";
        this.modalForm.endTime = "";
      }
    },
    // 重置
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.handleQuery();
    },
    // 查询
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let param = {
        ...this.formData,
        page_num: this.page_num,
        page_size: this.page_size
      };
      this.$api.getIndexList(param).then(res => {
        if (res.code === 0) {
          this.tableData = res.data;
           this.tableLoading = false;         
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 删除
    handleDel(params) {
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "删除消息"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              `确定删除该滚动消息么？`
            )
          ]);
        },
        onOk: () => {
          this.$api
            .indexMsgDel({
              id: params.row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.handleQuery();
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    handleModalSubmit() {
      if (!this.modalForm.document||!this.modalForm.startTime) {
        this.$Message.warning("请填写内容或时间");
        return;
      }
      this.modalLoading = true;    
      if (this.modalTitle === "添加滚动消息") {        
        this.$api.getIndexAdd({ ...this.modalForm }).then(res => {
          if (res.code === 0) {
            this.$Message.success(res.msg);
            this.modalVisibile = false;
            this.handleQuery();
            this.handleCancel();
          } else {
            this.$Message.error(res.msg);
          }
          this.modalLoading = false;
        });
      } else {
        this.$api.getIndexEdit({ ...this.modalForm }).then(res => {
          if (res.code === 0) {
            this.$Message.success(res.msg);
            this.modalVisibile = false;
            this.getTableData();
            this.handleCancel();
          } else {
            this.$Message.error(res.msg);
          }
          this.modalLoading = false;
        });
      }
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
      this.date = [];
    },
    //编辑
    addEdit(params) {
      if (params) {
        this.modalTitle = "编辑滚动消息";
        this.modalForm = Object.assign({}, this.modalForm1);
        this.modalForm.id = params.row.id;       
         this.modalForm.startTime = params.row.start_time;
         this.modalForm.endTime = params.row.end_time;
         this.modalForm.document = params.row.document;
         this.date=[params.row.start_time,params.row.end_time]
      } else {
        this.modalTitle = "添加滚动消息";
      }
      this.modalVisibile = true;
    },  
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.checkReset:first-child {
  margin-right: 8px;
}

.ivu-modal-footer {
  border-top: none !important;
}

.shadowLine {
  width: 660px;
  height: 1px;
  background: #e9e9e9;
  margin: 24px 0;
}

.wechartBox {
  width: 282px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  line-height: 32px;
  padding-left: 12px;

  span {
    width: 74px;
    text-align: center;
    border-left: 1px solid #dce1e6;
    cursor: pointer;
  }
}

/deep/ .ivu-upload-drag {
  border: none;
  background: transparent;
}

/deep/textarea.ivu-input {
  height: 115px;
}

.playFont {
  color: #8a9299;
}

.boldTitle {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.graybg {
  width: 724px;
  height: 12px;
  background: #f0f3f5;
  position: relative;
  left: -32px;
  margin-bottom: 24px;
  margin-top: 8px;
}

.shadowTitleClick span {
  cursor: pointer;
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
</style>
